export default __webpack_public_path__ + "static/1.5-Reading-Focus-Order-DO-ee914fe335beef36b671e18c4e42bade.png";